<template>
  <div>
    <div class="px-4 sm:px-0">
      <PageTitle
        :title="$gettext('FAQ')"/>
    </div>
  </div>
  <div class="divide-y divide-gray-200 overflow-hidden col-span-2 mt-4">
    <div v-if="faq" class="faq-content" v-html="md.render(faq)"></div>
  </div>
</template>

<script setup>
import PageTitle from "@/components/layout/PageTitle.vue";
import { ref, onMounted } from "vue";
import { useFaqStore } from "@/stores/faq";
import MarkdownIt from 'markdown-it'

const md = new MarkdownIt()

const faqStore = useFaqStore()
const faq = ref(null)

onMounted(async () => {
  await faqStore.fetchAll()
  let faqContent = faqStore.all.content
  faq.value = faqContent
});

</script>

<style>
.faq-content {
  font-family: system-ui, -apple-system, sans-serif;
  line-height: 1.7;
  color: #1f2937; /* gray-800 */
  max-width: 700px;
}

/* Headings */
.faq-content h1 {
  font-size: 2rem;
  font-weight: 700;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.faq-content h2 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
}
.faq-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

/* Paragraphs */
.faq-content p {
  margin-bottom: 1rem;
}

/* Strong / Bold */
.faq-content strong {
  font-weight: 600;
  color: #111827; /* gray-900 */
}

/* Lists */
.faq-content ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}
.faq-content ol {
  list-style-type: decimal;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}
.faq-content ol li {
  list-style-type: decimal;
}
.faq-content li {
  margin-bottom: 0.25rem;
}

/* Links */
.faq-content a {
  color: #2563eb; /* blue-600 */
  text-decoration: underline;
}
.faq-content a:hover {
  color: #1d4ed8; /* blue-700 */
}

/* Blockquotes */
.faq-content blockquote {
  border-left: 4px solid #d1d5db; /* gray-300 */
  padding-left: 1rem;
  color: #4b5563; /* gray-600 */
  font-style: italic;
  margin: 1rem 0;
}

/* Code blocks and inline code */
.faq-content pre {
  background: #f3f4f6; /* gray-100 */
  padding: 1rem;
  border-radius: 0.5rem;
  overflow-x: auto;
  margin: 1rem 0;
}
.faq-content code {
  font-family: ui-monospace, SFMono-Regular, monospace;
  background: #f9fafb;
  padding: 0.2rem 0.4rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}
</style>
